// extracted by mini-css-extract-plugin
export default {"fontSize1":"O4UaKY4FuHcWw2SioDQ3","fontSize2":"KZXhM3v44O4kHfwz2xZD","fontSize3":"zYD7jD9LmBQdjnWCO1NM","fontSize4":"_K_AeJp32QkrG7Zxm2IX","fontSize5":"a6eoiShzV7QgtDmMjvhP"};